import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost } from 'devextreme-angular/core';

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLoadPanelAnimationComponent = /*#__PURE__*/(() => {
  class DxoLoadPanelAnimationComponent extends NestedOption {
    get hide() {
      return this._getOption('hide');
    }
    set hide(value) {
      this._setOption('hide', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get _optionPath() {
      return 'animation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLoadPanelAnimationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelAnimationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLoadPanelAnimationComponent,
      selectors: [["dxo-load-panel-animation"]],
      inputs: {
        hide: "hide",
        show: "show"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLoadPanelAnimationComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLoadPanelAnimationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLoadPanelAnimationModule = /*#__PURE__*/(() => {
  class DxoLoadPanelAnimationModule {
    /** @nocollapse */static ɵfac = function DxoLoadPanelAnimationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelAnimationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLoadPanelAnimationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLoadPanelAnimationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLoadPanelAtComponent = /*#__PURE__*/(() => {
  class DxoLoadPanelAtComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'at';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLoadPanelAtComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelAtComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLoadPanelAtComponent,
      selectors: [["dxo-load-panel-at"]],
      inputs: {
        x: "x",
        y: "y"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLoadPanelAtComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLoadPanelAtComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLoadPanelAtModule = /*#__PURE__*/(() => {
  class DxoLoadPanelAtModule {
    /** @nocollapse */static ɵfac = function DxoLoadPanelAtModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelAtModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLoadPanelAtModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLoadPanelAtModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLoadPanelBoundaryOffsetComponent = /*#__PURE__*/(() => {
  class DxoLoadPanelBoundaryOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'boundaryOffset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLoadPanelBoundaryOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelBoundaryOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLoadPanelBoundaryOffsetComponent,
      selectors: [["dxo-load-panel-boundary-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLoadPanelBoundaryOffsetComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLoadPanelBoundaryOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLoadPanelBoundaryOffsetModule = /*#__PURE__*/(() => {
  class DxoLoadPanelBoundaryOffsetModule {
    /** @nocollapse */static ɵfac = function DxoLoadPanelBoundaryOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelBoundaryOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLoadPanelBoundaryOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLoadPanelBoundaryOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLoadPanelCollisionComponent = /*#__PURE__*/(() => {
  class DxoLoadPanelCollisionComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'collision';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLoadPanelCollisionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelCollisionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLoadPanelCollisionComponent,
      selectors: [["dxo-load-panel-collision"]],
      inputs: {
        x: "x",
        y: "y"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLoadPanelCollisionComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLoadPanelCollisionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLoadPanelCollisionModule = /*#__PURE__*/(() => {
  class DxoLoadPanelCollisionModule {
    /** @nocollapse */static ɵfac = function DxoLoadPanelCollisionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelCollisionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLoadPanelCollisionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLoadPanelCollisionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLoadPanelFromComponent = /*#__PURE__*/(() => {
  class DxoLoadPanelFromComponent extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get scale() {
      return this._getOption('scale');
    }
    set scale(value) {
      this._setOption('scale', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'from';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLoadPanelFromComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelFromComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLoadPanelFromComponent,
      selectors: [["dxo-load-panel-from"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLoadPanelFromComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLoadPanelFromComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLoadPanelFromModule = /*#__PURE__*/(() => {
  class DxoLoadPanelFromModule {
    /** @nocollapse */static ɵfac = function DxoLoadPanelFromModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelFromModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLoadPanelFromModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLoadPanelFromModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLoadPanelHideComponent = /*#__PURE__*/(() => {
  class DxoLoadPanelHideComponent extends NestedOption {
    get complete() {
      return this._getOption('complete');
    }
    set complete(value) {
      this._setOption('complete', value);
    }
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get staggerDelay() {
      return this._getOption('staggerDelay');
    }
    set staggerDelay(value) {
      this._setOption('staggerDelay', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'hide';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLoadPanelHideComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelHideComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLoadPanelHideComponent,
      selectors: [["dxo-load-panel-hide"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLoadPanelHideComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLoadPanelHideComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLoadPanelHideModule = /*#__PURE__*/(() => {
  class DxoLoadPanelHideModule {
    /** @nocollapse */static ɵfac = function DxoLoadPanelHideModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelHideModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLoadPanelHideModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLoadPanelHideModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLoadPanelMyComponent = /*#__PURE__*/(() => {
  class DxoLoadPanelMyComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'my';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLoadPanelMyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelMyComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLoadPanelMyComponent,
      selectors: [["dxo-load-panel-my"]],
      inputs: {
        x: "x",
        y: "y"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLoadPanelMyComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLoadPanelMyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLoadPanelMyModule = /*#__PURE__*/(() => {
  class DxoLoadPanelMyModule {
    /** @nocollapse */static ɵfac = function DxoLoadPanelMyModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelMyModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLoadPanelMyModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLoadPanelMyModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLoadPanelOffsetComponent = /*#__PURE__*/(() => {
  class DxoLoadPanelOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'offset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLoadPanelOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLoadPanelOffsetComponent,
      selectors: [["dxo-load-panel-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLoadPanelOffsetComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLoadPanelOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLoadPanelOffsetModule = /*#__PURE__*/(() => {
  class DxoLoadPanelOffsetModule {
    /** @nocollapse */static ɵfac = function DxoLoadPanelOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLoadPanelOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLoadPanelOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLoadPanelPositionComponent = /*#__PURE__*/(() => {
  class DxoLoadPanelPositionComponent extends NestedOption {
    get at() {
      return this._getOption('at');
    }
    set at(value) {
      this._setOption('at', value);
    }
    get boundary() {
      return this._getOption('boundary');
    }
    set boundary(value) {
      this._setOption('boundary', value);
    }
    get boundaryOffset() {
      return this._getOption('boundaryOffset');
    }
    set boundaryOffset(value) {
      this._setOption('boundaryOffset', value);
    }
    get collision() {
      return this._getOption('collision');
    }
    set collision(value) {
      this._setOption('collision', value);
    }
    get my() {
      return this._getOption('my');
    }
    set my(value) {
      this._setOption('my', value);
    }
    get of() {
      return this._getOption('of');
    }
    set of(value) {
      this._setOption('of', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get _optionPath() {
      return 'position';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLoadPanelPositionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelPositionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLoadPanelPositionComponent,
      selectors: [["dxo-load-panel-position"]],
      inputs: {
        at: "at",
        boundary: "boundary",
        boundaryOffset: "boundaryOffset",
        collision: "collision",
        my: "my",
        of: "of",
        offset: "offset"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLoadPanelPositionComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLoadPanelPositionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLoadPanelPositionModule = /*#__PURE__*/(() => {
  class DxoLoadPanelPositionModule {
    /** @nocollapse */static ɵfac = function DxoLoadPanelPositionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelPositionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLoadPanelPositionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLoadPanelPositionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLoadPanelShowComponent = /*#__PURE__*/(() => {
  class DxoLoadPanelShowComponent extends NestedOption {
    get complete() {
      return this._getOption('complete');
    }
    set complete(value) {
      this._setOption('complete', value);
    }
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get staggerDelay() {
      return this._getOption('staggerDelay');
    }
    set staggerDelay(value) {
      this._setOption('staggerDelay', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'show';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLoadPanelShowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelShowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLoadPanelShowComponent,
      selectors: [["dxo-load-panel-show"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLoadPanelShowComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLoadPanelShowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLoadPanelShowModule = /*#__PURE__*/(() => {
  class DxoLoadPanelShowModule {
    /** @nocollapse */static ɵfac = function DxoLoadPanelShowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelShowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLoadPanelShowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLoadPanelShowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLoadPanelToComponent = /*#__PURE__*/(() => {
  class DxoLoadPanelToComponent extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get scale() {
      return this._getOption('scale');
    }
    set scale(value) {
      this._setOption('scale', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'to';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLoadPanelToComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelToComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLoadPanelToComponent,
      selectors: [["dxo-load-panel-to"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLoadPanelToComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLoadPanelToComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLoadPanelToModule = /*#__PURE__*/(() => {
  class DxoLoadPanelToModule {
    /** @nocollapse */static ɵfac = function DxoLoadPanelToModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelToModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLoadPanelToModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLoadPanelToModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxoLoadPanelAnimationComponent, DxoLoadPanelAnimationModule, DxoLoadPanelAtComponent, DxoLoadPanelAtModule, DxoLoadPanelBoundaryOffsetComponent, DxoLoadPanelBoundaryOffsetModule, DxoLoadPanelCollisionComponent, DxoLoadPanelCollisionModule, DxoLoadPanelFromComponent, DxoLoadPanelFromModule, DxoLoadPanelHideComponent, DxoLoadPanelHideModule, DxoLoadPanelMyComponent, DxoLoadPanelMyModule, DxoLoadPanelOffsetComponent, DxoLoadPanelOffsetModule, DxoLoadPanelPositionComponent, DxoLoadPanelPositionModule, DxoLoadPanelShowComponent, DxoLoadPanelShowModule, DxoLoadPanelToComponent, DxoLoadPanelToModule };
